/* Surprise Your Love — booking.js
   Date + time-slot + duration + occasion + add-ons  →  /cart/add.js  →  /checkout
   Every choice is saved as line-item properties (visible on the Shopify order)
   and as cart attributes (order "Additional details"). */
(function () {
  'use strict';
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function fromIso(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  function prettyDate(d) { return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }
  function fmtTime(mins) {
    var h = Math.floor(mins / 60) % 24, m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ':' + pad(m) + ' ' + ap;
  }
  function hhmm(mins) { return pad(Math.floor(mins / 60)) + ':' + pad(mins % 60); }

  /* Parse "1 Hour", "1.5 Hours", "90 min", "2 hrs" → minutes */
  function durationMinutes(title) {
    if (!title) return 60;
    var t = String(title).toLowerCase();
    var m = t.match(/(\d+(?:[.,]\d+)?)\s*(m|min|mins|minute|minutes)\b/);
    if (m) return Math.round(parseFloat(m[1].replace(',', '.')));
    m = t.match(/(\d+(?:[.,]\d+)?)\s*(h|hr|hrs|hour|hours)?/);
    if (m) return Math.round(parseFloat(m[1].replace(',', '.')) * 60);
    return 60;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || '₹{{amount}}';
    function withDelims(num, precision, thousands, decimal) {
      var n = (num / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var val;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': val = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = withDelims(cents, 2, "'", '.'); break;
      default: val = withDelims(cents, 2, ',', '.');
    }
    val = val.replace(/\.00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function splitList(str) {
    return String(str || '').split(/[\n,;]+/).map(function (x) { return x.trim(); }).filter(Boolean);
  }

  function Booking(form) {
    this.form = form;
    try { this.cfg = JSON.parse(form.querySelector('[data-booking-config]').textContent); } catch (e) { this.cfg = {}; }
    var c = this.cfg;
    c.startHour = +c.startHour || 11;
    c.endHour = +c.endHour || 20;
    c.interval = +c.interval || 60;
    c.maxDays = +c.maxDays || 60;
    c.chipDays = Math.min(+c.chipDays || 14, c.maxDays);
    c.minAdvanceHours = +c.minAdvanceHours || 0;
    this.blocked = splitList(c.blockedDates);
    var handle = String(c.productHandle || '').toLowerCase();
    var rawBooked = String(c.bookedSlots || '').split(/[\n;]+/).concat(String(c.productBookedSlots || '').split(/[\n;,]+/));
    this.booked = rawBooked.map(function (s) { return s.trim().replace(/\s+/g, ' '); }).filter(Boolean).map(function (s) {
      var m = s.match(/^([a-z0-9][a-z0-9_-]*)\s*:\s*(\d{4}-\d{2}-\d{2}.*)$/i);
      if (!m) return s;
      return m[1].toLowerCase() === handle ? m[2].trim() : null;
    }).filter(Boolean);
    this.extra = {};
    var wk = splitList(c.closedWeekdays).map(function (s) { return s.slice(0, 3).toLowerCase(); });
    this.closedDays = DAYS.map(function (d, i) { return wk.indexOf(d.toLowerCase()) > -1 ? i : -1; }).filter(function (i) { return i > -1; });
    this.state = { date: null, time: null };
    this.init();
  }

  Booking.prototype.init = function () {
    var self = this, f = this.form;
    this.datesEl = f.querySelector('[data-dates]');
    this.slotsEl = f.querySelector('[data-slots]');
    this.dateLabel = f.querySelector('[data-date-label]');

    if (!f.querySelector('input[name="duration"]:checked')) {
      var first = f.querySelector('input[name="duration"]:not(:disabled)');
      if (first) first.checked = true;
    }
    this.renderDates();

    f.addEventListener('change', function (e) {
      var n = e.target.name;
      if (n === 'duration') { self.refreshDates(); self.renderSlots(); }
      if (n === 'date') { self.selectDate(e.target.value); }
      if (n === 'date-picker') { self.pickFromCalendar(e.target.value); }
      if (n === 'time') { self.state.time = +e.target.value; }
      if (n === 'addon') {
        var q = e.target.closest('.addon-opt').querySelector('[data-qty]');
        if (q) q.hidden = !e.target.checked;
      }
      var step = e.target.closest('.bstep');
      if (step) { step.classList.remove('has-error'); step.classList.add('is-done'); }
      var field = e.target.closest('.field');
      if (field) field.classList.remove('has-error');
      self.updateSummary();
    });
    f.addEventListener('input', function (e) {
      var field = e.target.closest('.field');
      if (field) field.classList.remove('has-error');
    });
    f.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-minus],[data-qty-plus]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var out = b.parentNode.querySelector('[data-qty-val]');
      var v = parseInt(out.textContent, 10) || 1;
      v = b.hasAttribute('data-qty-plus') ? Math.min(v + 1, 20) : Math.max(v - 1, 1);
      out.textContent = v;
      self.updateSummary();
    });
    f.addEventListener('click', function (e) {
      var more = e.target.closest('.date--more');
      if (!more) return;
      var di = more.querySelector('input[type="date"]');
      if (di && typeof di.showPicker === 'function') { try { di.showPicker(); } catch (err) {} }
    });
    f.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });

    /* Selections coming from occasion cards / pricing / add-on cards elsewhere on the page */
    document.addEventListener('syl:select', function (e) {
      var d = e.detail || {};
      if (d.occasion) {
        self.selectOccasion(d.occasion);
      }
      if (d.variant) {
        var v = f.querySelector('input[name="duration"][value="' + d.variant + '"]');
        if (v && !v.disabled) { v.checked = true; v.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      if (d.addon) {
        var a = f.querySelector('input[name="addon"][value="' + d.addon + '"]');
        if (a && !a.disabled) { a.checked = !!d.addonOn; a.dispatchEvent(new Event('change', { bubbles: true })); }
        else if (!a && d.addonPrice != null) {
          /* Add-on shown elsewhere on the page but not listed in this form: still add it to the booking */
          if (d.addonOn) self.extra[d.addon] = { id: +d.addon, title: d.addonTitle || 'Add-on', price: +d.addonPrice, qty: 1 };
          else delete self.extra[d.addon];
          self.updateSummary();
        }
      }
    });

    this.applyUrlParams();
    this.updateSummary();
  };

  /* Match "Date" to "Date Night", "birthday" to "Birthday", etc. */
  Booking.prototype.selectOccasion = function (want) {
    var w = String(want || '').trim().toLowerCase();
    if (!w) return;
    var inputs = Array.prototype.slice.call(this.form.querySelectorAll('input[name="occasion"]'));
    var hit = inputs.find(function (i) { return i.value.toLowerCase() === w; }) ||
      inputs.find(function (i) { var v = i.value.toLowerCase(); return v.indexOf(w) === 0 || w.indexOf(v) === 0; });
    if (hit) { hit.checked = true; hit.dispatchEvent(new Event('change', { bubbles: true })); }
  };

  /* Pre-fill from links like /products/boat?variant=123&occasion=Birthday&date=2026-10-14 */
  Booking.prototype.applyUrlParams = function () {
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    var f = this.form;
    var vid = q.get('variant');
    if (vid) {
      var v = f.querySelector('input[name="duration"][value="' + vid.replace(/\D/g, '') + '"]');
      if (v && !v.disabled) { v.checked = true; this.refreshDates(); }
    }
    if (q.get('occasion')) this.selectOccasion(q.get('occasion'));
    var dt = q.get('date');
    if (dt && /^\d{4}-\d{2}-\d{2}$/.test(dt)) {
      var chip = this.datesEl.querySelector('input[name="date"][value="' + dt + '"]');
      if (chip && !chip.disabled) { chip.checked = true; this.selectDate(dt); }
      else if (!chip) this.pickFromCalendar(dt);
    }
  };

  Booking.prototype.durationInput = function () { return this.form.querySelector('input[name="duration"]:checked'); };

  Booking.prototype.dateBlocked = function (d) {
    return this.blocked.indexOf(iso(d)) > -1 || this.closedDays.indexOf(d.getDay()) > -1;
  };

  Booking.prototype.today = function () { var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); };

  Booking.prototype.renderDates = function () {
    var html = '', today = this.today(), c = this.cfg;
    for (var i = 0; i < c.chipDays; i++) {
      var d = new Date(today); d.setDate(today.getDate() + i);
      var dis = this.dateBlocked(d) || !this.hasSlots(d);
      var top = i === 0 ? 'Today' : i === 1 ? 'Tmrw' : DAYS[d.getDay()];
      html += '<label class="date"><input type="radio" name="date" value="' + iso(d) + '"' + (dis ? ' disabled' : '') + '>' +
        '<span><small>' + top + '</small><b>' + d.getDate() + '</b><i>' + MONTHS[d.getMonth()] + '</i></span></label>';
    }
    if (c.maxDays > c.chipDays) {
      var max = new Date(today); max.setDate(today.getDate() + c.maxDays - 1);
      html += '<label class="date date--more"><span>' +
        '<svg class="icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg>More dates</span>' +
        '<input type="date" name="date-picker" aria-label="Pick another date" min="' + iso(today) + '" max="' + iso(max) + '"></label>';
    }
    this.datesEl.innerHTML = html;
    var firstOpen = this.datesEl.querySelector('input[name="date"]:not(:disabled)');
    if (firstOpen && this.cfg.autoSelectDate) { firstOpen.checked = true; this.selectDate(firstOpen.value); }
  };

  Booking.prototype.refreshDates = function () {
    var self = this;
    this.datesEl.querySelectorAll('input[name="date"]').forEach(function (i) {
      var d = fromIso(i.value);
      i.disabled = self.dateBlocked(d) || !self.hasSlots(d);
      if (i.disabled && i.checked) { i.checked = false; self.state.date = null; self.state.time = null; self.dateLabel.textContent = ''; }
    });
  };

  Booking.prototype.pickFromCalendar = function (val) {
    if (!val) return;
    var d = fromIso(val);
    var chip = this.datesEl.querySelector('input[name="date"][value="' + val + '"]');
    this.datesEl.querySelectorAll('input[name="date"]').forEach(function (i) { i.checked = false; });
    if (this.dateBlocked(d)) {
      this.state.date = null;
      this.dateLabel.textContent = 'Sorry, ' + prettyDate(d) + ' is unavailable. Please choose another date.';
      this.renderSlots();
      return;
    }
    if (chip && !chip.disabled) chip.checked = true;
    this.selectDate(val);
  };

  Booking.prototype.selectDate = function (val) {
    this.state.date = val;
    this.state.time = null;
    this.dateLabel.textContent = prettyDate(fromIso(val));
    this.renderSlots();
  };

  /* Slot start times (minutes from midnight) for a date & duration */
  Booking.prototype.slotsFor = function (d, durMins) {
    var c = this.cfg, out = [];
    var start = c.startHour * 60, end = c.endHour * 60;
    var last = c.mustEndBy ? end - durMins : end;
    var now = new Date();
    var cutoff = now.getTime() + c.minAdvanceHours * 3600000;
    var dayIso = iso(d);
    for (var t = start; t <= last; t += c.interval) {
      var slotDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), Math.floor(t / 60), t % 60);
      var past = slotDate.getTime() < cutoff;
      var taken = this.booked.indexOf(dayIso + ' ' + hhmm(t)) > -1 || this.booked.indexOf(dayIso + ' ' + fmtTime(t)) > -1;
      out.push({ t: t, disabled: past || taken, taken: taken });
    }
    return out;
  };

  Booking.prototype.hasSlots = function (d) {
    var inp = this.durationInput();
    var mins = inp ? durationMinutes(inp.getAttribute('data-title')) : 60;
    return this.slotsFor(d, mins).some(function (s) { return !s.disabled; });
  };

  Booking.prototype.renderSlots = function () {
    var inp = this.durationInput();
    var mins = inp ? durationMinutes(inp.getAttribute('data-title')) : 60;
    if (!this.state.date) {
      this.slotsEl.innerHTML = '<p class="slots__empty">Pick a date to see available slots.</p>';
      this.updateSummary();
      return;
    }
    var slots = this.slotsFor(fromIso(this.state.date), mins);
    var prev = this.state.time, keep = false, html = '';
    slots.forEach(function (s) {
      var id = 'slot-' + Math.random().toString(36).slice(2, 8);
      var checked = prev === s.t && !s.disabled;
      if (checked) keep = true;
      html += '<label class="slot" for="' + id + '"><input id="' + id + '" type="radio" name="time" value="' + s.t + '"' +
        (s.disabled ? ' disabled' : '') + (checked ? ' checked' : '') + '><span>' + fmtTime(s.t) +
        '<small>' + (s.taken ? 'Booked' : 'till ' + fmtTime(s.t + mins)) + '</small></span></label>';
    });
    if (!slots.some(function (s) { return !s.disabled; })) {
      html = '<p class="slots__empty">No slots left on this date — please choose another day.</p>';
    }
    if (!keep) this.state.time = null;
    this.slotsEl.innerHTML = html;
    this.updateSummary();
  };

  Booking.prototype.addons = function () {
    var extra = this.extra || {};
    return Object.keys(extra).map(function (k) { return extra[k]; }).concat(Array.prototype.map.call(this.form.querySelectorAll('input[name="addon"]:checked'), function (i) {
      var q = i.closest('.addon-opt').querySelector('[data-qty-val]');
      return { id: +i.value, title: i.getAttribute('data-title'), price: +i.getAttribute('data-price'), qty: q ? (parseInt(q.textContent, 10) || 1) : 1 };
    }));
  };

  Booking.prototype.updateSummary = function () {
    var f = this.form, fmt = this.cfg.moneyFormat;
    var set = function (k, v) { var el = f.querySelector('[data-sum="' + k + '"]'); if (el) el.textContent = v; };
    var row = function (k, show) { var el = f.querySelector('[data-sum-row="' + k + '"]'); if (el) el.hidden = !show; };
    var dur = this.durationInput();
    var total = dur ? +dur.getAttribute('data-price') : 0;
    set('duration', dur ? dur.getAttribute('data-title') + ' · ' + formatMoney(dur.getAttribute('data-price'), fmt) : '—');
    var when = '—';
    if (this.state.date) {
      var dd = fromIso(this.state.date);
      when = DAYS[dd.getDay()] + ' ' + dd.getDate() + ' ' + MONTHS[dd.getMonth()] + (this.state.time != null ? ', ' + fmtTime(this.state.time) : ' · pick a time');
    }
    set('when', when);
    var occ = f.querySelector('input[name="occasion"]:checked');
    row('occasion', !!occ); if (occ) set('occasion', occ.value);
    var ads = this.addons();
    row('addons', ads.length > 0);
    set('addons', ads.map(function (a) { total += a.price * a.qty; return a.title + (a.qty > 1 ? ' ×' + a.qty : ''); }).join(', '));
    set('total', formatMoney(total, fmt));
    if (this.cfg.isProductPage) {
      var sp = document.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = formatMoney(total, fmt);
      var sl = document.querySelector('.sticky-book__label');
      if (sl && dur) sl.textContent = dur.getAttribute('data-title');
    }
  };

  Booking.prototype.validate = function () {
    var f = this.form, errs = [];
    function stepErr(name, bad) {
      var st = f.querySelector('[data-step="' + name + '"]');
      if (st) st.classList.toggle('has-error', bad);
      if (bad && st) errs.push(st);
    }
    stepErr('duration', !this.durationInput());
    stepErr('date', !this.state.date);
    stepErr('time', this.state.time == null);
    if (f.querySelector('[data-step="occasion"]')) stepErr('occasion', !f.querySelector('input[name="occasion"]:checked'));

    var name = f.querySelector('[name="name"]'), phone = f.querySelector('[name="phone"]'), email = f.querySelector('[name="email"]');
    var digits = (phone.value || '').replace(/\D/g, '');
    var badName = name.value.trim().length < 2;
    var badPhone = digits.length < 10 || digits.length > 13;
    var badEmail = email && email.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());
    name.closest('.field').classList.toggle('has-error', badName);
    phone.closest('.field').classList.toggle('has-error', badPhone);
    if (email) email.closest('.field').classList.toggle('has-error', !!badEmail);
    if (badName) errs.push(name.closest('.field'));
    if (badPhone) errs.push(phone.closest('.field'));
    if (badEmail) errs.push(email.closest('.field'));

    if (errs.length) {
      errs[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    return true;
  };

  Booking.prototype.showError = function (msg) {
    var el = this.form.querySelector('[data-error]');
    el.textContent = msg;
    el.classList.toggle('is-visible', !!msg);
  };

  Booking.prototype.submit = function () {
    var self = this, f = this.form, c = this.cfg;
    this.showError('');
    if (!this.validate()) return;

    var dur = this.durationInput();
    var d = fromIso(this.state.date);
    var mins = durationMinutes(dur.getAttribute('data-title'));
    var val = function (n) { var el = f.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
    var occ = f.querySelector('input[name="occasion"]:checked');

    var dateText = prettyDate(d);
    var timeText = fmtTime(this.state.time) + ' – ' + fmtTime(this.state.time + mins);

    /* Visible on the order line item (and in order notification emails) */
    var props = {
      'Booking Date': dateText,
      'Time Slot': timeText,
      'Duration': dur.getAttribute('data-title')
    };
    if (occ) props['Occasion'] = occ.value;
    if (val('guests')) props['Guests'] = val('guests');
    props['Name'] = val('name');
    props['Phone'] = val('phone');
    if (val('email')) props['Email'] = val('email');
    if (val('celebrant')) props['Decoration Name'] = val('celebrant');
    if (val('notes')) props['Special Requests'] = val('notes');

    var items = [{ id: +dur.value, quantity: 1, properties: props }];
    this.addons().forEach(function (a) {
      items.push({ id: a.id, quantity: a.qty, properties: { 'For Booking': dateText + ', ' + fmtTime(self.state.time) } });
    });

    /* Order-level "Additional details" */
    var attributes = {
      'Booking Date': dateText,
      'Booking Date (YYYY-MM-DD)': this.state.date,
      'Time Slot': timeText,
      'Duration': dur.getAttribute('data-title'),
      'Occasion': occ ? occ.value : '',
      'Guests': val('guests'),
      'Customer Name': val('name'),
      'Customer Phone': val('phone'),
      'Customer Email': val('email'),
      'Decoration Name': val('celebrant'),
      'Special Requests': val('notes'),
      'Add-ons': this.addons().map(function (a) { return a.title + (a.qty > 1 ? ' x' + a.qty : ''); }).join(', ')
    };
    var note = 'BOOKING: ' + dateText + ' | ' + timeText + ' | ' + dur.getAttribute('data-title') +
      (occ ? ' | ' + occ.value : '') + ' | ' + val('name') + ' ' + val('phone');

    var btn = f.querySelector('[data-submit]');
    var label = f.querySelector('[data-submit-label]');
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    label.textContent = c.loadingText || 'Securing your slot…';

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var post = function (url, body) {
      return fetch(root + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body || {})
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong');
          return j;
        });
      });
    };

    var chain = c.clearCart !== false ? post('cart/clear.js') : Promise.resolve();
    chain
      .then(function () { return post('cart/add.js', { items: items }); })
      .then(function () { return post('cart/update.js', { attributes: attributes, note: note }); })
      .then(function () {
        var totalCents = +dur.getAttribute('data-price');
        self.addons().forEach(function (a) { totalCents += a.price * a.qty; });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'syl_booking_submit', booking_date: self.state.date, booking_time: fmtTime(self.state.time), duration: dur.getAttribute('data-title'), occasion: occ ? occ.value : '', value: totalCents / 100 });
        window.location.href = root + (c.redirect === 'cart' ? 'cart' : 'checkout');
      })
      .catch(function (err) {
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
        label.textContent = c.buttonText || 'Book Now';
        self.showError((err && err.message) || 'Could not start checkout. Please try again or message us on WhatsApp.');
      });
  };

  function boot() {
    document.querySelectorAll('[data-booking-form]').forEach(function (f) {
      if (!f.__booking) f.__booking = new Booking(f);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
